<template lang="html">
  <div>
    <vx-card class="grid-view-item mb-base overflow-hidden">
      <template slot="no-body">
      <div class="item-img-container bg-white h-64 flex items-center justify-center mb-4 cursor-pointer">
        <img :src="'https://cotizador.socasesores.com/uploads/'+ item.Logo" :alt="item.Banco" class="grid-view-img p-4">
      </div>
      <div class="item-details px-4">
        <h4 class="item-name font-semibold mb-1 hover:text-primary cursor-pointer" style="margin-top:2%">{{ item.Producto }}</h4>
        <div class="flex justify-between items-center">
          <h6 class="font-bold">Mensualidad ${{ numberFormat(item.MensualidadPromedio) }}</h6>
        </div>
        <div class="my-4">
          <p class="text-sm mb-4">Pago <span class="font-semibold cursor-pointer">{{ item.Esquema==2 ? 'Fijo' : 'Creciente' }}</span> durante <span class="font-semibold cursor-pointer">{{ item.Plazo/12 }} años</span></p>
          <p class="item-description text-sm">Tasa {{ item.Tasa }}%</p>
          <p class="item-description text-sm">Cat {{ numberFormat(item.Cat) }}%</p>
        </div>
      </div>
      </template>
      <vs-button class="w-full" @click="elegirProducto(item)">Elegir producto</vs-button>
    </vx-card>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
export default {
  props: {
    item: {
      type: Object,
      required: true
    },
  },
  data(){
    return{
    }
  },
  computed:{
    ...mapState(['casoId','key']),
  },
  methods:{
    numberFormat(num){
      return num.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    elegirProducto(item){
      let self=this
      var objRequestSolicitaCaso = {
        strApiKey: this.key,
        strMetodo: "Solicita",
        intVariante: item.Id,
        objCaso: {
         Id: this.casoId
        }
      }
      this.$axios.post('/',objRequestSolicitaCaso,{headers : {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}})
      .then(
        response => {
          if (response.data.intEstatus == 0) {
            this.$vs.notify({
              title:`Solicitado exitosamente ${item.Id}`,
              text:`${item.Producto}`,
              position:'top-right',
            })
            this.$emit('next')
          }else {
            this.$vs.notify({
              title:'Ocurrio un error en Solicita',
              text:response.data.strError,
              color:'danger',
              position:'top-right'
            })
          }
        }
      ).catch(function (error) {
        self.$vs.notify({
          title:'Ocurrio un error de sistema',
          text:error,
          color:'danger',
          position:'top-right'
        })
      })
    },
  }
}
</script>

<style lang="css" scoped>
@media only screen and (max-width: 700px) {
  img, .item-details{
    margin-top: -25%;
  }
}
</style>
